export default "images/logo-unram.png";